import type { FC } from 'react';

import { useGetOrganizationPosts } from '@/features/api/hooks/grapevine-post/useGetOrganizationPosts';
import { OrganizationPostsList } from '@/features/posts/components/organization-posts/OrganizationPostsList';
import { SIZE } from '@/features/posts/constants/params';
import type { ProfileSettingRoute } from '@/features/profile-setting/navigation/profileSettingRoute';
import type { AppNativeStackScreenProps } from '@/navigation/types/navigation';
import { GradientBackground } from '@/shared/components/GradientBackground';

type Props = AppNativeStackScreenProps<
  typeof ProfileSettingRoute.OrganizationPosts
>;

export const OrganizationPostsScreen: FC<Props> = ({ route }) => {
  const { organizationId } = route.params;
  const {
    data: posts,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    refetch,
    isRefetching
  } = useGetOrganizationPosts(organizationId, {
    count: SIZE
  });

  return (
    <GradientBackground>
      <OrganizationPostsList
        posts={posts}
        isLoading={isLoading}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetching={isFetching}
        isFetchingNextPage={isFetchingNextPage}
        refetch={refetch}
        isRefetching={isRefetching}
        hideEndView
      />
    </GradientBackground>
  );
};
